export type SinkGroupStatusName =
  | 'Reported'
  | 'Suspicious'
  | 'Confirmed'
  | 'NotAProblem'
  | 'Remediated'
  | 'Fixed'
  | 'AutoRemediated'
  | 'Multiple'

export class SinkGroupStatus {
  public static readonly REPORTED = new SinkGroupStatus(
    'Reported',
    'title_vulnerabilityStatusReported'
  )
  public static readonly SUSPICIOUS = new SinkGroupStatus(
    'Suspicious',
    'title_vulnerabilityStatusSuspicious'
  )
  public static readonly CONFIRMED = new SinkGroupStatus(
    'Confirmed',
    'title_vulnerabilityStatusConfirmed'
  )
  public static readonly NOT_A_PROBLEM = new SinkGroupStatus(
    'NotAProblem',
    'title_vulnerabilityStatusNotProblem'
  )
  public static readonly REMEDIATED = new SinkGroupStatus(
    'Remediated',
    'title_vulnerabilityStatusRemediated'
  )
  public static readonly FIXED = new SinkGroupStatus(
    'Fixed',
    'title_vulnerabilityStatusFixed'
  )
  public static readonly AUTO_REMEDIATED = new SinkGroupStatus(
    'AutoRemediated',
    'title_vulnerabilityStatusAutoRemediated'
  )

  public static readonly MULTIPLE = new SinkGroupStatus(
    'Multiple',
    'title_vulnerabilityStatusMultiple'
  )

  public static readonly all: SinkGroupStatus[] = [
    SinkGroupStatus.REPORTED,
    SinkGroupStatus.SUSPICIOUS,
    SinkGroupStatus.CONFIRMED,
    SinkGroupStatus.NOT_A_PROBLEM,
    SinkGroupStatus.REMEDIATED,
    SinkGroupStatus.FIXED,
    SinkGroupStatus.AUTO_REMEDIATED,
    SinkGroupStatus.MULTIPLE
  ]

  public static fromName = (name: SinkGroupStatusName): SinkGroupStatus => {
    const status = SinkGroupStatus.all.find((status) => status.name === name)

    if (!status) {
      throw new Error(`Unknown SinkGroupStatus: ${name}`)
    }

    return status
  }

  constructor(readonly name: SinkGroupStatusName, readonly i18nID: string) {}
}
